export * from './SmallerTextBox';
export * from './TableHeadingText';
export * from './TableMobileHeadingText';
export * from './TextPrice';
export * from './TextPriceTruncated';
export * from './TextWithLineLimit';
export * from './Typography';
